import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/auth/slice";
import schoolSlice from "./slices/school/slice";
import userSlice from "./slices/user/slice";
import studentSlice from "./slices/student/slice";
import staffSlice from "./slices/staff/slice";
import classesSlice from "./slices/class/slice";
import teacherSlice from "./slices/teacher/slice";
import eventsSlice from "./slices/events/slice";
import periodSlice from "./slices/period/slice";
import notificationsSlice from "./slices/notifications/slice";
import periodEventDataSlice from "./slices/periodEventData/slice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    school: schoolSlice,
    userInfo: userSlice,
    studentInfo: studentSlice,
    staffInfo: staffSlice,
    classes: classesSlice,
    teachers: teacherSlice,
    events: eventsSlice,
    period: periodSlice,
    notifications: notificationsSlice,
    periodEventData: periodEventDataSlice,
  },
});
